function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 50,
  fill: "#FFF0D1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.1624 57.7965C71.1911 59.4943 71.465 62.5171 69.774 64.5481L53.6798 83.8784C51.9888 85.9094 48.9733 86.1795 46.9446 84.4817C44.9158 82.7839 44.642 79.7611 46.333 77.7301L51.4153 71.6259L51.4605 67.996C51.4693 67.2866 51.7211 66.6023 52.1736 66.0575L58.3071 58.6735C59.3757 57.3871 61.2707 57.1898 62.5829 58.2218C64.2982 56.3544 67.1945 56.1496 69.1624 57.7965Z",
  fill: "#1B72B0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.1831 58.4522C86.2046 56.4188 85.3863 53.9384 83.3553 52.9121L76.5008 49.4485C74.4698 48.4222 71.9953 49.2386 70.9738 51.272L65.9721 61.2285C64.9506 63.2619 65.769 65.7422 67.7999 66.7685L74.6544 70.2322C76.6854 71.2585 79.1599 70.442 80.1814 68.4087L85.1831 58.4522Z",
  fill: "#256DA2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M61.3864 39.2489C49.8946 30.2366 44.7216 23.8381 38.4985 8.65198L12.5035 60.3956C28.376 56.3743 36.5614 56.7768 50.6219 60.6759L61.3864 39.2489Z",
  fill: "#A9DBFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M79.9781 53.2481C80.9996 51.2147 80.1812 48.7343 78.1502 47.708L61.3653 39.2263L50.5982 60.6596L67.3831 69.1413C69.4141 70.1676 71.8886 69.3512 72.91 67.3178L79.9781 53.2481Z",
  fill: "#38A2EF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M60.2709 41.4839L59.6193 42.7616C49.9551 38.9667 39.8798 24.2064 35.588 18.3879L26.1482 37.1328L55.4533 51.0115L54.4777 52.97L74.8124 63.4086L74.4496 64.1862L80.6901 67.3006C81.2251 66.2136 84.2996 60.1196 84.2996 60.1196C84.2996 60.1196 85.7598 57.6706 85.2182 57.2349C83.6547 56.423 79.4985 54.09 79.4985 54.09C80.0781 52.8096 79.6535 51.6053 77.6767 50.49C75.6999 49.3746 60.2709 41.4839 60.2709 41.4839Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 1.93521,
  height: 58.71,
  rx: 0.967606,
  transform: "matrix(0.892668 0.450715 -0.449189 0.893437 38.5186 8.21899)",
  fill: "#256DA1"
});

var SvgAwarenessIcon = function SvgAwarenessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAwarenessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awareness-icon.4d8030c3.svg";
export { ForwardRef as ReactComponent };